export default __webpack_public_path__ + "static/company-website-ff0be4ffd6641ea8c214e60a332cc9aa.png";